import { useEffect, useRef, useState, useCallback } from 'react';
import { Stack, Button, Title, Loader, Box } from '@mantine/core';
import { notifications } from '@mantine/notifications';
import { useNavigate } from 'react-router-dom';
import { WHEEL_SLUG } from '../../utils/cvdl';
import { WheelCanvas } from './WheelCanvas';
import { useKiosk } from '../../context/KioskContext/KioskContext';
import { api } from '../../wheel-api/client';
import { getDeviceId } from './device';

export function SpinScreen() {
  const { attendee, setSpinResult, setIsSpinning } = useKiosk();
  const [prizes, setPrizes] = useState([]);
  const [targetSlot, setTargetSlot] = useState(null);
  const [busy, setBusy] = useState(false);
  const resultRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.getWheelPublic(WHEEL_SLUG)
      .then(w => setPrizes(w.prizes))
      .catch(() => notifications.show({ message: 'No pudimos cargar la ruleta', color: 'red' }));
  }, []);

  async function girar(esReintento = false) {
    setBusy(true);
    try {
      const res = await api.spin(WHEEL_SLUG, {
        attendeeId: attendee._id,
        deviceId: getDeviceId(),
      });
      resultRef.current = { ...res, name: attendee.name };
      setIsSpinning(true);
      setTargetSlot(res.slot);
    } catch (err) {
      if (err.code === 'ALREADY_SPUN_TODAY') {
        setSpinResult({
          alreadySpun: !esReintento,
          slot: err.data.slot, prizeLabel: err.data.prizeLabel,
          code: err.data.code, spinId: err.data.spinId, name: attendee.name,
        });
        navigate('/kiosk/premio');
        return;
      }
      if ((err.code === 'TIMEOUT' || err.code === 'NETWORK') && !esReintento) {
        return girar(true);
      }
      notifications.show({ message: 'No pudimos girar. Probá de nuevo.', color: 'red' });
      setBusy(false);
      setIsSpinning(false);
    }
  }

  const alFrenar = useCallback(() => {
    setIsSpinning(false);
    setSpinResult(resultRef.current);
    navigate('/kiosk/premio');
  }, [navigate, setSpinResult, setIsSpinning]);

  if (!prizes.length) {
    return <Stack align="center" justify="center" style={{ flex: 1 }}><Loader size="xl" /></Stack>;
  }

  return (
    <Stack align="center" justify="center" style={{ flex: 1 }} gap="md">
      <Title order={3} c="forvet.7" ta="center" style={{ fontSize: 'clamp(20px, 3vh, 32px)' }}>
        Hola, {attendee.name.split(' ')[0]}
      </Title>

      <Box style={{ width: 'min(52vh, 88vw)' }}>
        <WheelCanvas prizes={prizes} targetSlot={targetSlot} onSettled={alFrenar} />
      </Box>

      <Button
        h={78} w={400} radius="xl"
        loading={busy} disabled={targetSlot !== null}
        onClick={() => girar()}
        style={{ boxShadow: '0 4px 16px rgba(23,63,110,.18)' }}
      >
        GIRAR
      </Button>
    </Stack>
  );
}